module.exports = __webpack_public_path__ + "img/glasses_female_square.620b5b88.png";